import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import { DayPickerRangeController, isInclusivelyAfterDay, isInclusivelyBeforeDay } from 'react-dates'
import { END_DATE } from 'react-dates/constants'
import moment from 'moment'

import { CancelButton, MainButton } from 'components/button'

import styles from './date_range_picker.scss'

class DateRangePicker extends PureComponent {
	constructor() {
		super()
		this.onFocusChange = this.onFocusChange.bind(this)
		this.onDatesChange = this.onDatesChange.bind(this)
		this.isOutsideRange = this.isOutsideRange.bind(this)
		this.save = this.save.bind(this)
		this.state = {
			focusedInput: END_DATE,
			startDate: null,
			endDate: null,
		}
	}

	onFocusChange() {
		//this.setState({ focusedInput: focusedInput || START_DATE })
	}

	onDatesChange(date) {
		this.setState({ endDate: date.endDate })
		this.props.dateChangeHandler([date.endDate.year(), date.endDate.month()+1, date.endDate.date()])
	}

	isOutsideRange(day) {
		const now = moment()
		return (!isInclusivelyAfterDay(day, now) ||
			!isInclusivelyBeforeDay(day, moment(this.dateForMoment(this.props.startDate)).add('days', this.props.maxDays)) ||
			this.props.shouldDisableDay(day))
	}

	save() {
		this.props.saveHandler([this.state.endDate.year(), this.state.endDate.month()+1, this.state.endDate.date()])
	}

	dateForMoment(date) {
		/* moment expect months from 0 to 11 */
		const newDate = [...date]
		newDate[1] = newDate[1]-1
		return newDate
		/* ---- */
	}

	componentDidMount() {
		if (this.props.startDate) {
			this.setState({ startDate: moment(this.dateForMoment(this.props.startDate)) })
		}
		if (this.props.endDate) {
			this.setState({ endDate: moment(this.dateForMoment(this.props.endDate)) })
		}
	}

	render() {
		return (
			<div styleName={cn({
				wrapper: true,
				'fixed-height': this.props.fixedHeight,
			})}>
				<DayPickerRangeController
					numberOfMonths={2}
					minimumNights={this.props.minimumNights}
					onFocusChange={this.onFocusChange}
					focusedInput={this.state.focusedInput}
					onDatesChange={this.onDatesChange}
					startDate={this.state.startDate}
					endDate={this.state.endDate}
					isOutsideRange={this.isOutsideRange}
					daySize={24}
					hideKeyboardShortcutsPanel
					noBorder
					navPrev='<'
					navNext='>'
				/>
				<div styleName='button-bar'>
					<div styleName='button-bar-button'>
						<CancelButton onClick={this.props.cancelHandler} size='small'>Cancel</CancelButton>
					</div>
					<div styleName='button-bar-button'>
						<MainButton onClick={this.save} size='small'>Apply</MainButton>
					</div>
				</div>
			</div>
		)
	}
}

DateRangePicker.defaultProps = {
	dateChangeHandler: () => {},
	fixedHeight: false,
	shouldDisableDay: () => false,
}

DateRangePicker.propTypes = {
	shouldDisableDay: PropTypes.func,
}

export default CSSModules(DateRangePicker, styles, {allowMultiple: true})
